import React from 'react';
import { Check, Mail } from 'lucide-react';
import { motion } from 'framer-motion';
export function HeroSection() {
  return <section className="relative px-5 py-14 md:py-20 flex flex-col items-center text-center overflow-hidden" style={{
    background: 'radial-gradient(ellipse at center, #FFF0F4 0%, #FFFFFF 70%)'
  }} data-id="element-15">
      <div className="max-w-[640px] w-full mx-auto flex flex-col items-center" data-id="element-16">
        {/* Animated check with pulsing ring */}
        <div className="relative" data-id="element-17">
          <span className="absolute inset-0 rounded-full aurora-pulse" style={{
          background: 'linear-gradient(135deg, #E32F6E 0%, #D2A96E 100%)'
        }} data-id="element-18" />
          <motion.div initial={{
          scale: 0
        }} animate={{
          scale: [0, 1.1, 1]
        }} transition={{
          duration: 0.6,
          ease: 'easeOut',
          delay: 0.3
        }} className="relative w-[100px] h-[100px] rounded-full flex items-center justify-center" style={{
          background: 'linear-gradient(135deg, #E32F6E 0%, #D2A96E 100%)',
          boxShadow: '0 8px 32px rgba(227, 47, 110, 0.3)'
        }} data-id="element-19">
            <Check className="w-12 h-12 text-white" strokeWidth={3} data-id="element-20" />
          </motion.div>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.8,
        ease: 'easeOut'
      }} className="font-display font-bold text-aurora-dark text-[28px] md:text-[40px] leading-tight mt-7" data-id="element-21">
          Compra confirmada! 🎉
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 1.0,
        ease: 'easeOut'
      }} className="mt-3 space-y-1" data-id="element-22">
          <p className="text-aurora-pink font-bold text-[17px] md:text-[20px]" data-id="element-23">
            Bem-vinda à Aurora.
          </p>
          <p className="text-aurora-gray text-[15px] md:text-[18px] font-normal" data-id="element-24">
            Sua gestão financeira começa agora.
          </p>
        </motion.div>

        {/* Email card */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 1.2,
        ease: 'easeOut'
      }} className="bg-white border-[1.5px] border-aurora-border rounded-[20px] py-5 px-5 md:px-6 mt-8 flex items-start gap-4 text-left w-full shadow-[0_4px_16px_rgba(0,0,0,0.04)]" data-id="element-25">
          <div className="shrink-0 w-10 h-10 rounded-full flex items-center justify-center" style={{
          backgroundColor: '#FFF0F4'
        }} data-id="element-26">
            <Mail className="w-5 h-5 text-aurora-pink" strokeWidth={2.2} data-id="element-27" />
          </div>
          <p className="text-[14px] md:text-[15px] text-aurora-gray leading-relaxed pt-1.5" data-id="element-28">
            Enviamos um email com suas instruções de acesso. Verifique também a
            pasta de spam.
          </p>
        </motion.div>

        {/* CTA */}
        <motion.a initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 1.4,
        ease: 'easeOut'
      }} whileHover={{
        scale: 1.03,
        boxShadow: '0 16px 40px rgba(227, 47, 110, 0.55)'
      }} whileTap={{
        scale: 0.98
      }} href="https://app.myaurora.com.br?utm_source=hotmart&utm_medium=pos_compra&utm_campaign=obrigado" target="_blank" rel="noopener noreferrer" className="text-white font-bold text-[17px] md:text-[18px] py-5 px-12 rounded-[14px] mt-7 w-full md:w-auto" style={{
        background: 'linear-gradient(135deg, #E32F6E 0%, #C9295F 100%)',
        boxShadow: '0 12px 32px rgba(227, 47, 110, 0.45)',
        transition: 'all 200ms ease'
      }} data-id="element-29">
          Acessar o Aurora agora
        </motion.a>
      </div>
    </section>;
}